<div class="modal-header">
  <h3 class="modal-title">Skip Automatic Payroll Confirmation</h3>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Are you sure you want to skip the automatic payroll run for</p>
  <p>
    Period End: {{ periodEndDate | date: 'MM/dd/yyyy' }}<br />
    Pay Date: {{ payDate | date: 'MM/dd/yyyy' }}
  </p>
  <p></p>
  <p>Skipping the worksheet will remove the automatic payroll for this period end and pay date.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary me-auto" (click)="cancel()">Don't skip</button>
  <button type="button" class="btn btn-secondary me-2" (click)="skip()">Skip</button>
  <button type="button" class="btn btn-primary me-2" (click)="skipAndNavigate()">
    Skip and go to payroll
  </button>
</div>
